// --- utilities
import {
  Scrolllable,
  BrowserCheck,
  Dropify,
  Modal,
  CustomSelect,
  ChangeFormatNumber,
  FormWizard,
  DatePickerInput,
  FullScreen,
  ButtonEvent,
  EditableTable,
} from "utilities";

// --- components
import {
  Reseller,
  Customer,
  Order,
  InputDropdown,
  Dashboard,
  User,
  Role,
  Gallery,
  SelectData,
  Product,
} from "components";

// --- App
const App = (() => {
  // --- run transition
  const runTransition = () => {
    $("body").removeClass("hold-transition");
  };

  // --- show site content
  const showSiteContent = () => {
    $(".js-main-site").removeClass("main-site--hide");
    // --- disable scroll
    Scrolllable.enable();
  };

  // --- ready
  const ready = () => {
    (($) => {
      // --- disable scroll
      Scrolllable.disable();
      // --- Global
      runTransition();
      showSiteContent();
      BrowserCheck.init();
      Modal.init();
      Dropify.init();
      CustomSelect.init();
      ChangeFormatNumber.init();
      FormWizard.init();
      DatePickerInput.init();
      FullScreen.init();
      ButtonEvent.init();
      EditableTable.init();
      // --- Project
      Reseller.init();
      Customer.init();
      Order.init();
      InputDropdown.init();
      Dashboard.init();
      User.init();
      Role.init();
      Gallery.init();
      SelectData.init();
      Product.init();
    })(jQuery);
  };

  // --- load
  const load = () => {
    (($) => {
      $(window).on("load", () => {});
    })(jQuery);

    $(".form-control").on("click", function () {
      $(this).focus();
    });

    // When the append is clicked, focus the input
    // $(".input-group-append").on("click", function () {
    //   $(this)
    //     .closest(".input-group-custom")
    //     .find("input, textarea, select")
    //     .first()
    //     .focus();
    // });

    $(".form-control").on("click", function () {
      $(this).focus();
    });

    $(document).on("click", ".js-show-password", function () {
      const input = $("#password");
      const icon = $(this).find("i");

      if (input.attr("type") === "password") {
        input.attr("type", "text");
        icon.removeClass("ph-eye-closed").addClass("ph-eye");
      } else {
        input.attr("type", "password");
        icon.removeClass("ph-eye").addClass("ph-eye-closed");
      }
    });

    // ✅ Tooltip click (mobile)
    $(document).on("click", ".tooltip-wrapper", function (e) {
      e.stopPropagation();

      const $this = $(this);

      // close others
      $(".tooltip-wrapper").not($this).removeClass("active");

      // toggle current
      $this.toggleClass("active");
    });

    // close tooltip when clicking outside
    $(document).on("click", function () {
      $(".tooltip-wrapper").removeClass("active");
    });
  };

  const handleRunTemporatyAlert = () => {
    setTimeout(function () {
      $(".js-temporary-alert").slideUp(300);
    }, 3000);
    setTimeout(function () {
      $(".js-temporary-alert").remove();
    }, 3350);
  };

  // --- init
  const init = () => {
    load();
    ready();
    handleRunTemporatyAlert();
  };

  // --- return
  return {
    init,
  };
})();

// ---  run main js
App.init();
